export function initRelatedSlider() {
  const carousel = document.querySelector('.related-carousel');
  if (!carousel) return;

  const trackWrapper = carousel.querySelector('.related-track-wrapper');
  const prevBtn = carousel.querySelector('.related-nav--prev');
  const nextBtn = carousel.querySelector('.related-nav--next');
  
  if (!trackWrapper || !prevBtn || !nextBtn) return;

  const track = carousel.querySelector('.related-track');
  if (!track) return;

  // Infinite Scroll Setup
  const originalCards = Array.from(track.children);
  const cardCount = originalCards.length;
  if (cardCount === 0) return;

  // Clone items for infinite loop (Prepend and Append)
  originalCards.forEach(card => {
    const clone = card.cloneNode(true);
    clone.classList.add('clone-append');
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  });

  originalCards.slice().reverse().forEach(card => {
    const clone = card.cloneNode(true);
    clone.classList.add('clone-prepend');
    clone.setAttribute('aria-hidden', 'true');
    track.prepend(clone);
  });

  const getCardWidthWithGap = () => {
    const card = track.querySelector('.related-card');
    if (!card) return 0;
    const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
    return card.offsetWidth + gap;
  };

  const getSetWidth = () => {
    return getCardWidthWithGap() * cardCount;
  };

  // Initial positioning to the middle set
  const centerScroll = () => {
    const setWidth = getSetWidth();
    trackWrapper.scrollLeft = setWidth;
  };

  // We need to wait for layout/rendering before setting initial scroll
  // setTimeout 0 puts it at end of event loop
  setTimeout(centerScroll, 0);
  
  // Also handle resize to maintain relative position if needed, 
  // but for now simple re-centering logic might be enough or just letting user scroll.
  // Actually, resize changes widths, so we should re-adjust scroll if we were "aligned".
  // But let's stick to the infinite loop check.

  const scrollAmount = () => getCardWidthWithGap();

  prevBtn.addEventListener('click', () => {
    trackWrapper.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
  });

  nextBtn.addEventListener('click', () => {
    trackWrapper.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
  });

  let isScrolling;

  const checkInfiniteScroll = () => {
    const setWidth = getSetWidth();
    // Tolerance buffer
    const buffer = 5; 

    // If scrolled into the prepend clones (left side)
    if (trackWrapper.scrollLeft < setWidth - buffer) {
      // Jump forward to the real set
      // Calculate how far we are from the "end" of the prepend set
      // and map that to the "end" of the real set?
      // No, simpler: map current position to the equivalent position in the middle set.
      // Current pos: x. Equivalent pos: x + setWidth.
      
      // Wait, if I am at index 0 (Prepend 1), I correspond to Real 1 (index N).
      // Index 0 scrollLeft is approx 0.
      // Real 1 scrollLeft is approx setWidth.
      // So newPos = currentPos + setWidth.
      
      // We must be careful about "looping". 
      // If we are at 0, we jump to setWidth.
      
      // If we are at setWidth - 100, we jump to 2*setWidth - 100.
      
      trackWrapper.scrollLeft += setWidth;
    }
    
    // If scrolled into the append clones (right side)
    // The "Real" set ends at 2 * setWidth.
    // If scrollLeft >= 2 * setWidth, we are in append clones.
    else if (trackWrapper.scrollLeft >= 2 * setWidth - buffer) {
       trackWrapper.scrollLeft -= setWidth;
    }
  };

  trackWrapper.addEventListener('scroll', () => {
    // Clear timeout if scrolling
    window.clearTimeout(isScrolling);
    
    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(() => {
      // Check boundaries and jump silently
      // We use 'auto' behavior (default) for instant jump if we modify scrollLeft directly
      // However, modifying scrollLeft directly IS instant.
      checkInfiniteScroll();
    }, 100); // 100ms debounce
  });

  // Handle window resize
  window.addEventListener('resize', () => {
     // Ideally we might want to re-center or adjust, 
     // but just ensuring we are in bounds is enough.
     checkInfiniteScroll();
  });
}
